module.exports = __webpack_public_path__ + "images/home_4096.jpg";